import { render, staticRenderFns } from "./ProjectHousing.vue?vue&type=template&id=5feef50b&scoped=true"
import script from "./ProjectHousing.vue?vue&type=script&lang=js"
export * from "./ProjectHousing.vue?vue&type=script&lang=js"
import style0 from "./ProjectHousing.vue?vue&type=style&index=0&id=5feef50b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feef50b",
  null
  
)

export default component.exports